import React from 'react';
import type { RedcatIconProps } from './RedcatIcon';
import { REDCAT_ICON_DEFAULT_COLOR, REDCAT_ICON_DEFAULT_SIZE } from './RedcatIcon';

const RedcatMapPinIcon = ({
  size = REDCAT_ICON_DEFAULT_SIZE,
  color = REDCAT_ICON_DEFAULT_COLOR,
}: RedcatIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14.9997C13 15.7954 13.3161 16.5584 13.8787 17.121C14.4413 17.6836 15.2044 17.9997 16 17.9997C16.7956 17.9997 17.5587 17.6836 18.1213 17.121C18.6839 16.5584 19 15.7954 19 14.9997C19 14.2041 18.6839 13.441 18.1213 12.8784C17.5587 12.3158 16.7956 11.9997 16 11.9997C15.2044 11.9997 14.4413 12.3158 13.8787 12.8784C13.3161 13.441 13 14.2041 13 14.9997Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.657 20.6567L17.414 24.8997C17.039 25.2743 16.5306 25.4848 16.0005 25.4848C15.4704 25.4848 14.962 25.2743 14.587 24.8997L10.343 20.6567C9.22422 19.5379 8.46234 18.1124 8.15369 16.5606C7.84504 15.0087 8.00349 13.4002 8.60901 11.9384C9.21452 10.4767 10.2399 9.22725 11.5555 8.34821C12.8711 7.46918 14.4178 7 16 7C17.5822 7 19.1289 7.46918 20.4445 8.34821C21.7601 9.22725 22.7855 10.4767 23.391 11.9384C23.9965 13.4002 24.155 15.0087 23.8463 16.5606C23.5377 18.1124 22.7758 19.5379 21.657 20.6567Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RedcatMapPinIcon;
